import React from 'react'
import { getImageUrl } from '../../utils/mediaDeliveryUrls'

export default function RepoImage({
  repo,
  className = '',
  width = 450,
  height = 450,
  autoFormatAndQuality = false,
  versionOverride = null, // to force container update on image change/upload
}) {
  const transformations = autoFormatAndQuality ?
    `c_fill,f_auto,h_${height},q_auto,w_${width}` : // standard media service transform order
    `c_fill,h_${height},w_${width}`
  const version = versionOverride || repo.image
  return (
    <img
      src={getImageUrl(repo.id, { folderPath: '/repo', version, transformations })}
      key={repo.id}
      className={className}
      alt='Repository cover'
      width={width}
      height={height}
    />
  )
}
